import { render, staticRenderFns } from "./EmpzoneColContentForm.vue?vue&type=template&id=2af6a3c8&"
import script from "./EmpzoneColContentForm.vue?vue&type=script&lang=js&"
export * from "./EmpzoneColContentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2af6a3c8')) {
      api.createRecord('2af6a3c8', component.options)
    } else {
      api.reload('2af6a3c8', component.options)
    }
    module.hot.accept("./EmpzoneColContentForm.vue?vue&type=template&id=2af6a3c8&", function () {
      api.rerender('2af6a3c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/empzone/colContent/modules/EmpzoneColContentForm.vue"
export default component.exports